import { testimonials } from "@/mocks/comics";

const values = [
  {
    icon: "ri-timer-flash-line",
    title: "开刷零等待",
    desc: "榜单、分类、专题全部帮你整理好，点开就能速食开挂剧情，不用在茫茫书海中翻找，时间每一秒都花在看得爽上。",
  },
  {
    icon: "ri-medal-2-line",
    title: "榜单够硬核",
    desc: "热血战斗排行综合热度、评分与口碑动态生成，龙傲天与打脸爽文漫按真实人气排序，跟着榜单走不会踩雷。",
  },
  {
    icon: "ri-compass-3-line",
    title: "分类超精准",
    desc: "热血战斗、开挂主角、逆袭流、龙傲天、打脸爽文等类型一网打尽，想刷哪种爽直接进入对应频道精准开刷。",
  },
];

export default function WhySection() {
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 pb-14 md:pb-20">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-10 items-center">
        <div>
          <span className="text-xs font-semibold tracking-widest text-primary-400">WHY US</span>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl text-foreground-950">为什么爱上炮渣漫画网</h2>
          <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
            我们只做一件事：把最好看的无脑爽漫推荐到你的眼前。无论是拳拳到肉的热血战斗，
            还是一路碾压的开挂主角，这里都能让你一口气看爽，不用翻找，直接开刷。
          </p>
          <div className="mt-8 flex flex-col gap-4">
            {values.map((v) => (
              <div key={v.title} className="flex gap-4 rounded-lg bg-background-100 border border-background-300/50 p-5">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                  <i className={`${v.icon} text-xl`}></i>
                </span>
                <div>
                  <h3 className="font-heading text-base md:text-lg text-foreground-950">{v.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 用户口碑 */}
        <div>
          <div className="flex items-center gap-3 mb-5">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-quote-text text-xl"></i>
            </span>
            <div>
              <h2 className="font-heading text-xl md:text-2xl text-foreground-950">读者口碑</h2>
              <p className="text-xs text-foreground-600">来自追漫老铁们的真实评价</p>
            </div>
          </div>
          <div className="flex flex-col gap-4">
            {testimonials.map((t) => (
              <figure key={t.name} className="rounded-lg bg-background-100 border border-background-300/50 p-5">
                <div className="flex items-center gap-0.5 text-accent-400 mb-3">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <blockquote className="text-sm leading-relaxed text-foreground-600">“{t.content}”</blockquote>
                <figcaption className="mt-3 flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500/20 text-primary-400">
                    <i className="ri-user-3-fill"></i>
                  </span>
                  <div>
                    <div className="text-sm font-semibold text-foreground-950">{t.name}</div>
                    <div className="text-xs text-foreground-600">{t.role}</div>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}